import React, {Component, Fragment} from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {SVGIcon} from '@homeaway/react-svg';
import {ATTACHMENT__16} from '@homeaway/svg-defs/lib/defs/ATTACHMENT__16';
import {SUCCESS__16} from '@homeaway/svg-defs/lib/defs/SUCCESS__16';

import {copyLink} from './SocialShareActions';

import './SocialShareCopy.less';

export default class SocialShareCopy extends Component {
    state = {
        isOpen: false,
    };

    handleCopy = () => {
        /* istanbul ignore else */
        if (!this.state.isOpen) {
            this.setState({isOpen: true}, () => {
                copyLink();
                setTimeout(() => {
                    this.setState({isOpen: false});
                }, 1250);
            });
        }
    };

    content = () => {
        const {copiedText} = this.props;

        return (
            <Fragment>
                <SVGIcon markup={SUCCESS__16} />
                <p>{copiedText}</p>
            </Fragment>
        );
    };

    render() {
        const {isOpen} = this.state;

        return (
            <Fragment>
                <Tooltip
                    portalClassName="SocialShareCopy"
                    trigger="click"
                    isOpen={isOpen}
                    placement="top"
                    content={this.content()}
                    centered
                >
                    <button onClick={this.handleCopy} label="Copy URL link">
                        <SVGIcon markup={ATTACHMENT__16} />
                    </button>
                </Tooltip>
            </Fragment>
        );
    }
}
